// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_printable__oFoeh","nonPrintable":"styles_nonPrintable__gPrIU","link":"styles_link__GjpTj"};